import store from '@/store'
import useNotifications from '@/composables/useNotifications'
import { useRouter } from '@core/utils/utils'
// import { addProcess } from '@/@core/queries/process'
import i18n from '@/libs/i18n'
import { ref } from '@vue/composition-api'
import { useLambda } from '@/views/habit/awsLambda'
import { oid } from '@/helpers/mongoHelpers'
import { hasPermission } from '@/composables/usePermission'

export default function useProcessAdd() {
  const userData = store.state?.userStore?.userData
  const { showSuccessMessage, showErrorMessage } = useNotifications()
  const { router } = useRouter()
  const { createItem } = useLambda()
  const isSubmitting = ref(false)
  const collection = 'process'

  const storeData = async payload => {
    if (!hasPermission('risks', 'create')) {
      showErrorMessage(i18n.t('message.you_are_not_authorized'))
      return
    }

    // isSubmitting.value = true

    payload.client_id = oid(userData.client.$oid)
    payload.crimes = payload.crimes?.map(e => oid(e.value)) || []
    payload.areas = payload.areas?.map(e => oid(e.value)) || []
    payload.controls = payload.controls?.map(e => oid(e)) || []
    payload.responsibles = payload.responsibles?.map(e => oid(e)) || []
    payload.leadResponsibles = payload.leadResponsibles?.map(e => oid(e)) || []
    payload.evaluator = payload.evaluator ? oid(payload.evaluator) : null
    payload.evaluated = payload.evaluated ? oid(payload.evaluated) : null
    payload.residualRisk = payload.residualRisk?.value || null
    payload.residualRiskProbability = payload.residualRiskProbability?.value || null
    payload.residualRiskImpact = payload.residualRiskImpact?.value || null
    payload.inherentRisk = payload.inherentRisk?.value || null
    payload.inherentRiskProbability = payload.inherentRiskProbability?.value || null
    payload.inherentRiskImpact = payload.inherentRiskImpact?.value || null
    payload.company = payload.company ? oid(payload.company) : null
    payload.id = payload.id ? oid(payload.id) : null

    try {
      await createItem({ collection, payload })
      showSuccessMessage(i18n.t('message.form_success'))
    } catch (error) {
      console.log(error)
      showErrorMessage(i18n.t('message.process_error'))
    } finally {
      router.push({ name: 'organization-process-list' })
      isSubmitting.value = false
    }
  }

  return {
    storeData,
    isSubmitting,
  }
}
